import {Box3} from "three";
import {CutOut} from "./cutOut";
import {createGroup, findChildByName, getLengthByAxis} from "../../utils/threeUtils";
import {getWallGroupParent} from "../../utils/configuratorUtils";
import {cutOutsGroupName} from "../../constants/nameConstants";
import {recalculateBuildingParameters} from "../../calculators/buildingParameters/parameterCalculator";

export class Door extends CutOut {
    create(wallGroup = null, wallMeshName = null) {
        if (!this.placeable) {
            return false;
        }

        let wallMesh = wallGroup === null ? this.getMeshToCut() : findChildByName(wallGroup, wallMeshName);
        if (wallMesh === null) {
            return false;
        }

        wallGroup = getWallGroupParent(wallMesh); //Get the wallGroup the element is currently hovering on

        let adjustOriginalWall = false;
        let originalWallGroup = null;
        //Wenn der CutOut recreated ist muss geprüft werden ob die Wand die gleiche wie vorher ist sonst muss die alte Wand auch nachher angepasst werden
        if (this.recreated) {
            originalWallGroup = CutOut.clearOldCutOut(this.controlObject);
            adjustOriginalWall = wallGroup !== originalWallGroup;
        }

        if (wallGroup === null) {
            return false;
        }


        let bounds = new Box3().setFromObject(wallMesh);
        //TODO: Temp fix für falsch gerenderte Durchbrüche
        if (this.setHeightToWallHeight) {
            this.height = getLengthByAxis(bounds, "y"); //Get group height
        }
        let cutOutsGroup = findChildByName(wallGroup, cutOutsGroupName);
        this.cutOutGroup = createGroup("doorGroup", cutOutsGroup); //TODO: Check If not null
        this.cutMesh = this.createCuttingMesh();
        this.cutWallSegment(wallGroup);
        wallGroup.updateMatrix();
        for (let i = 0; i < wallGroup.children.length; i++) {
            wallGroup.children[i].updateMatrix();
        }
        this.createControlObject(wallGroup, wallMesh.name);


        if (adjustOriginalWall) {
            CutOut.adjustWall(originalWallGroup);
        }

        CutOut.adjustWall(wallGroup);

        recalculateBuildingParameters().then();

        return true;
    }

    createCuttingMesh() {
        let cuttingMesh = super.createCuttingMesh();
        cuttingMesh.name = "doorCutMesh";
        return cuttingMesh;
    }

    setControlObjectUserData(wallMeshName, sceneMatrix) {
        super.setControlObjectUserData(wallMeshName, sceneMatrix);
        this.controlObject.userData.type = "door";
    }
}
